document.addEventListener('click', function (e) {
  var swatch = e.target.closest('[data-swatch-image]');
  if (!swatch) return;

  e.stopImmediatePropagation();
  e.stopPropagation();
  e.preventDefault();

  var src = swatch.getAttribute('data-swatch-image');
  var productId = swatch.getAttribute('data-product-id');
  var card = document.querySelector('product-card[data-product-id="' + productId + '"]');
  if (!card) return;

  var img = card.querySelector('img');
  if (img && src) {
    img.src = src;
    img.srcset = src;
  }
}, true);

document.addEventListener('pointerdown', function (e) {
  if (e.target.closest('[data-swatch-image]')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
  }
}, true);
